import {
    DynamicListAddButton,
    DynamicListWrapperProps,
    ValidatedDynamicListFormComponentProps,
    ValidatedInput
} from '@finbeat/react-toolkit';
import { OrderStatus } from 'models/api/orderStatus';
import { Trans } from 'react-i18next';
import { Table } from 'reactstrap';

const TimeoutFormWrapper = ({ children, ...props }: DynamicListWrapperProps) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th>
                        <Trans i18nKey={'BackOfficeTimeoutSecs'} />
                    </th>
                    <th>
                        <Trans i18nKey={'BackOfficeAction'} />
                    </th>
                    <th>
                        <Trans i18nKey={'BackOfficeActionAdditionalInfo'} />
                    </th>
                    <th>
                        <Trans i18nKey={'BackOfficeActionAdditionalData'} />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

const TimeoutForm = ({ idx, fieldId, checkDouble }: ValidatedDynamicListFormComponentProps) => {
    return (
        <>
            <td>
                <ValidatedInput<OrderStatus> name={`timeouts.${idx}.timeout`} isFloating={false} />
            </td>
            <td>
                <ValidatedInput<OrderStatus> name={`timeouts.${idx}.action`} isFloating={false} />
            </td>
            <td>
                <ValidatedInput<OrderStatus>
                    name={`timeouts.${idx}.actionAdditionalInfo`}
                    isFloating={false}
                />
            </td>
            <td>
                <ValidatedInput<OrderStatus>
                    name={`timeouts.${idx}.actionAdditionalData`}
                    isFloating={false}
                />
            </td>
        </>
    );
};

export { TimeoutForm, TimeoutFormWrapper };
